{
  "Account Alone Using Credential": "There is only one account using this credential",
  "Account Alone Using Remote": "There is only one account using this remote",
  "Account Not Exists": "The entered account does not exist",
  "Accounts": "Accounts",
  "Accounts Must Not Be Maestronet": "Login can not be 'maestronet' for an airline user",
  "Accounts Using Credential Count": "There are {{ count }} remote accounts using this credential",
  "Accounts Using Remote Count": "There are {{ count }} remote accounts using this remote",
  "Actions": "Actions",
  "Active Users": "Active Users",
  "Add New Accounts To User": "Add new accounts to user",
  "Agency": "Travel agency",
  "Agency Role Must Be Unique Role": "Agency role must be the unique role",
  "Agent": "Agent",
  "Agents": "Agents",
  "Agents Groups": "Agents Groups",
  "Airline": "Airline",
  "airline": "airline",
  "Airline Already Exists": "Some entered airline is already associated to other customer",
  "Airline Code": "Airline code ",
  "Airline Not Belong Customer": "Airline on this account does not belong to this customer",
  "Airline Three Digits": "Airline format must be 3 digits",
  "Airline In": " airline in ",
  "Airlines In": " airlines in ",
  "Airlines & Countries": "Airlines & Countries",
  "Agent Macro Group": "Agent macro group",
  "ALL": "ALL",
  "ALL MALE": "ALL",
  "ALL FEMALE": "ALL",
  "All Countries": "All countries",
  "All Customers": "All customers",
  "All Documents": "All documents",
  "Allowed IPs": "Allowed IP's",
  "Allowed Types Files": "Allowed types files: {{ allowedTypesFiles }}",
  "Amount": "Amount",
  "Apply": "Apply",
  "Apps": "Applications",
  "arc": "ARC",
  "ARM Communication": "ARM Communication",
  "Assigned": "Assigned",
  "Assigned To": "Assigned To",
  "AssignedTooTo": "Also Assigned To",
  "Attachments": "Attachments",
  "Attachment Long Size": "The file size is greater than the limit ({{ quantityMax }}MB). Please, generate a report with a shorter period range (from.. to..)",
  "Awaiting feedback": "Awaiting feedback",
  "Back": "Back",
  "body": "body",
  "Body": "Body",
  "Body Characters Minimum Communications": "The body must have at least 5 characters",
  "Body Message": "Body Message",
  "Body Message Required": "Body message required",
  "BookingClasses": "Booking classes",
  "bsp": "BSP",
  "BSP Not Found Airline Customer": "Bsp does not found for airline of this customer",
  "Change User Password": "Are you sure you want to change user's password?",
  "Check Email IPM": "An error occurred getting the customers information. Please check support email",
  "Choose one country": "Select at least one country",
  "Choose One Product To Continue": "You must choose at least one product in order to continue",
  "Closed": "Closed",
  "Closed date": "Closed date",
  "Comment Required If Verified": "Could not change status to 'Verified' without a comment",
  "Comment Saved Correctly": "Comment has been added to the communication",
  "Comments": "Comments",
  "comments": "comments",
  "Commissioned Tickets": "Commissioned Tickets",
  "Commission": "Commission",
  "Commissions": "Commissions",
  "Communication Details": "Communication details",
  "Communication Updated Correctly": "Communication updated correctly",
  "Communication Sent": "Communication has been sent",
  "Communications Limited": "Search results are limited to the 1000 most recent matches.",
  "Compare": "Compare",
  "Compare Deal": "Compare",
  "Confirm Password Is Not The Same": "Confirm password is not the same than new password",
  "Confirmation": "Confirmation",
  "Consider Following": "Consider the following",
  "Connection Extra Parameters": "Connection extra parameters",
  "Contact Email": "Contact email",
  "Contact Name": "Contact name",
  "Contact Phone": "Contact phone",
  "Contact With Support": " and contact with customer support",
  "Content": "Content",
  "Contract Code": "Contract code",
  "Contract Code Already Exists": "There is already a communication with not-closed status for the same contract code, customer and country",
  "Contract Code Error": "The following characters can not be used: space( ), single quote('), double quote(\") and ampersands(&)",
  "Contract Code Required": "Could not save a contract request communication without a country associated",
  "Contract Management Login": "Login successful with ",
  "Contract Name Description": "Contract name descripcion",
  "Contract Request": "Contract request",
  "Contracts": "Contracts",
  "Conversion": "Convert to:",
  "Countries": "Countries",
  "Countries And Airlines": "Countries and airlines",
  "Country": "Country",
  "Countries Space": " countries",
  "Country Space": " country",
  "Country Not Belong Customer": "Country on this account does not belong to this customer",
  "Country Two Characters": "The country format must have 2 characters (digits -0-9- and/or capital letters -A-Z-)",
  "Create": "Create",
  "Create Account": "Create account",
  "Create Association Per Product": "You must create at least one association per product: [ ' {{ currentProduct }} ' ] doesn't have any, please check Tab 'Countries And Airlines'",
  "Create Maestro Account": "Create Net remit Maestronet account",
  "Create New Account": "Create new account",
  "Create New Credential": "Create new credential",
  "Create New Remote": "Create new remote",
  "Created by": "Created by",
  "Credential": "Credential",
  "Credential Description": "Credential description",
  "Credential Updated": "Credential updated successfully",
  "CRM": "CRM",
  "Currencies": "Currencies",
  "Currency": "Currency",
  "Customer": "Customer",
  "CustomerId Required To Admin": "Customer id is required being admin",
  "Customer Not Found" : "A problem ocurred getting information about customer. Please, contact with customer support",
  "Customer Reference": "Customer reference",
  "Customer Reference Error": "Only alphanumeric characters are allowed",
  "Customers": "Customers",
  "Customers Administration": "Customers Administration",
  "Data In File": "* Included in file",
  "Date Closure": "Date of closure",
  "Day Month": "Day of month",
  "Day Week": "Day of week",
  "Days": "days",
  "Deal Comparison": "Deal comparison",
  "Description": "Description",
  "Destination": "Destination",
  "Delete": "Delete",
  "Delete Maestronet Account": "Delete maestronet account",
  "Details": "Details",
  "DB Connections": "DB Connections",
  "db-ifx": "Informix",
  "db-ss": "Sql server",
  "Disabled": "Disabled",
  "Discarded": "Discarded",
  "Display days": "* Display limited to the last {{maxDaysInGraphics}} days selected",
  "Display months": "Display limited to 3 months",
  "Documentation Message" : "Click to get information about ",
  "Download": "Download",
  "Download Doc": "Download Doc",
  "Download Graphic" : "Download graphic",
  "Download Response File" : "Download response file",
  "Download Sent File" : "Download sent file",
  "Due Date": "Due Date",
  "Duplicated Account": "Duplicated account. Please, introduce a different one",
  "Edit Credential": "Edit credential",
  "Edit Remote": "Edit remote",
  "Edit User Profile": "Edit user profile",
  "Email": "Email",
  "Email Required": "Email is required",
  "Email Sent Correctly": "Email sent correctly",
  "Email Separator": "The valid separator between emails is a semicolon (;), comma (,) or space",
  "Enabled": "Enabled",
  "endTaskDateError:Incorrect EndTaskDate. Higher Equal Extraction Start Date": "Incorrect extraction end date. It must be higher or equal than extraction start date",
  "endTaskDateError:Incorrect EndTaskDate. Higher Equal Today": "Incorrect extraction end date. It must be higher or equal than today",
  "entries": "Entries",
  "Error Analytics":"An error occurred while processing your request, please check your analytics configuration",
  "Error Cancelling Payment":"An error occurred while cancelling the payment",
  "Error Communication Saved":"You cannot change the country or code of the agreement once the WS-API has processed the communication",
  "Error Creating Threshold Contract": "An error occurred while saving the new threshold contract",
  "Error File Download": "An error occurred while downloading the payment file. Please contact with customer support",
  "Error Generic": "An unexpected error occurred. Please contact with customer support",
  "Error Generic Onload": "An error occurred while loading the page data. Please contact with customer support",
  "Error Getting Communication": "An error happened to get the information about communication",
  "Error Invalid Form": "Cannot save this communication due to errors in the form",
  "Error Loading MacroGroups File": "An error happened trying to load the macro-groups file",
  "Error No Enabled Database For Country": "There is no configured database for this country",
  "Error On Request":"An error occurred while performing this operation",
  "Error Search Graphic": "The search has failed",
  "Error User": "The search has failed when searching the user data",
  "Error Updating Status File": "An error happened to update the status of file. Please contact with customer support",
  "Error Updating Task": "An error occurred while trying to update template of the task",
  "Error ThresholdContracts Delete": "An error occurred deleting a threshold contract",
  "Error ThresholdContract Not Found": "Threshold Contract not found",
  "Esmash Request": "Esmash request",
  "Excel Not Exists": "The file is not enable. Please, regenerate it again",
  "Exclusions": "Exclusions",
  "Expired": "Your password has expired. Click on 'I forgot my password' to get a new password",
  "Expire Date": "Expire Date",
  "Exports Data XLSX": "Exports data as XLSX",
  "Extraction Start Date": "Extraction start date",
  "File Masstask or ARC": "Masstask / ARC file",
  "File Name": "File Name",
  "Fare": "Fare",
  "Farebasis": "Farebasis",
  "Filter": "Filter",
  "Filter Message": "Search by name, email..",
  "Filter Records": "Filter records",
  "First Page": "First",
  "Flight Days": "Flight days",
  "Flight Numbers": "Flight numbers",
  "Following Errors Ocurred": "Following errors occurred",
  "Following Info Ocurred": "Information",
  "Following Warning Ocurred": "Following warning ocurred",
  "from": "from",
  "From": "From",
  "sftp-down": "Sftp for downloads",
  "sftp-up": "Sftp for uploads",
  "Gateway Timeout": "Connection Lost. Please verify your internet connection",
  "Go Back": "Go back",
  "GNR5 Communication": "GNR5 Communication",
  "GNR5 Customer Support": "GNR5 Customer Support",
  "Groups": "Groups",
  "Help": "Help",
  "Hide Deal": "Hide deal",
  "History": "History",
  "Hour": "Hour",
  "In progress": "In progress",
  "Incorrect Alpha Numeric Simbols Format": "Accepts alphanumeric characters in addition to: hyphen(-), space( ), dot(.), simple quote(') and apostrophe(´)",
  "Incorrect Alpha Numeric DISH Format": "Accepts alphanumeric characters according to DISH 'Data Representation' chapter: A-Z 0-9 and ./-()*$\\",
  "Incorrect ContractCode Format": "The  following characters can not be used: space( ), simple quote('), doble quote(\") and ampersands(&).",
  "Incorrect Current Password": "Current password is incorrect.",
  "Incorrect EndTaskDate Higher Equal Extraction Start Date": "Incorrect extraction end date. It must be higher or equal than extraction start date.",
  "Incorrect EndTaskDate Higher Equal Today": "Incorrect extraction end date. It must be higher or equal than today.",
  "Incorrect MacroGroup File Format In Line": "The macro-groups file format is incorrect in line: ",
  "Incorrect MacroGroup File Format In Lines": "The macro-groups file format is incorrect in lines: ",
  "Incorrect Numeric Format": "Only numbers",
  "Incorrect Phone Format": "Incorrect phone format. Characters that can be used: Numbers, hyphen(-), space( ), slash(/) and sum operator(+) at the beginning",
  "Incorrect URL Format": "Accepts alphanumeric characters according to URL format: A-Z 0-9 and .-_~",
  "Index": "Index",
  "Instance Name": "Instance name (only db)",
  "Internal Error": "An error happened to try to delete the get the information to connect. Please, try it later",
  "Internal Server Error": "An unexpected error occurred. Please contact with customer support",
  "Invalid File Type": "Invalid file type",
  "Invalid Path": "Attachments could not be loaded",
  "Invalid IsoAlpha2 Chain": "An error occurred trying to get customers. Please contact with customer support",
  "Implementation": "Implementation",
  "IPM DB TimeOut": "An error occurred during data collection. Please contact with customer support",
  "Ipm Not Properly Configured": "Couldn't reach the database associated with the client, please check if the IPM database is properly configured",
  "IPM Server Not Found": "An error ocurred trying to connect to server. Please, check the settings of connection",
  "Issue": "Issue",
  "Issue Date": "Issue date",
  "Issue Periods": "Issue Periods",
  "KPI Dashboard": "KPI Dashboard",
  "Last Page": "Last",
  "Leave": "Leave",
  "Length ContractCode": " The contract code length must be minimum of {{ quantityMin }} characters and maximum of {{ quantityMax }}",
  "Length Maximum App Name": "The maximum length app name are {{ quantityMax }} characters",
  "Length Maximum App Description": "The maximum length app description are {{ quantityMax }} characters",
  "Length Maximum Contact Email": "The maximum contact email length are {{ quantityMax }} characters",
  "Length Maximum Contact Name": "The maximum contact name length are {{ quantityMax }} characters",
  "Length Maximum Contact Phone": "The maximum contact phone length are {{ quantityMax }} characters",
  "Length Maximum Customer Reference": "The maximum length customer reference are {{ quantityMax }} characters",
  "Length Maximum Minimum Body": "The minimum length body must be {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Cc": "The minimum length Cc are {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Comments": "The minimum length comments are {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Current Password": "The minimum length current password are 8 characters and maximum 100",
  "Length Maximum Minimum From": "The minimum length 'from' are {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Login": "The minimum length login must be {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Password": "The minimum length password must be {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Maximum Minimum Subject": "The minimum length subject must be {{ quantityMin }} characters and maximum {{ quantityMax }}",
  "Length Minimum Body": "The minimum current body length are {{ quantityMax }} characters",
  "Length Minimum Current Password": "The minimum current password length are {{ quantityMax }} characters",
  "Length Minimum Subject": "The minimum current subject length are {{ quantityMax }} characters",
  "Length Required Country": "The length country code must be {{ quantityMax }} characters",
  "Length Required Document": "Document length must be {{ quantityMin }} digits",
  "Life Span": "Life span (days)",
  "List of Contracts Is Empty": "List of contracts is empty",
  "List of Contracts Not Available": "Error retrieving the list of contracts",
  "Loading": "Loading",
  "Lock": "Lock",
  "Lock User": "Lock User",
  "Login Name": "Login Name",
  "Login Only Alphanumerics Dash": "Login should only contain letters, numbers, dash or underscore",
  "MacroGroups Load": "Macro-Groups Load",
  "MacroGroups Load Success": "Load of macro-groups file '{{ fileName }}' has been successful",
  "MaestroLogin Accounts": "MaestroLogin accounts",
  "manual-capture-bsp": "Manual Capture BSP",
  "manual-capture-arc": "Manual Capture ARC",
  "Max 3 Files Allowed": "Max. 3 files allowed",
  "Max Flight Date": "Max flight date",
  "Maximum Months": "Maximum {{ maxMonthsAllowed }} months",
  "Maximum Size Request": "The sum of files should not be not greater than 28 mb",
  "MaxSelectedRangeDate": "Max. {{maxMonthsInGraphics}} months",
  "Max Value MaxRelated": "The entered value is higher than the maximum",
  "Max Value MaxRelated With Detail": "The entered value is higher than the maximum (by default: {{ default }}, in {{ diffCountry }} is {{ diffValue }})",
  "Memo Auditor Role Must Have Another Extra GNR5 Role": "Memo audit role must have another extra GNR5 role",
  "Memo Auditor Role Must Not Be Unique Role": "Memo audit can not be the only role",
  "Memo Content": "Memo Content",
  "Memo Content Origin" : "Memo content origin",
  "Message Filtered From": "(filtered from ",
  "Message Filtered Total": " total entries)",
  "Message Info Table Showing": "Showing {{minValuePage}} to {{maxValuePage}} of {{total}}",
  "Message Zero Records": "No matching records found",
  "Minutes": "Minutes",
  "Mixed Conditions Not Available": "Mixed Conditions are not available for this contract",
  "Month": "Month",
  "Name":"Name",
  "Name App":"Application name",
  "Months": "months",
  "NEW": "NEW",
  "New": "New",
  "New Communication": "New communication",
  "New Credential": "New credential",
  "New Customer": "New customer",
  "New Profile": "New Profile",
  "New Remote": "New remote",
  "New User": "New User",
  "Next From Doc": "Next From doc",
  "Next Page": "Next",
  "Next Execution": "Next execution",
  "Nobody": "Nobody",
  "None": "None",
  "No Comments": "There are no comments",
  "No Conversion": "No conversion",
  "No Countries": "Associated Maestronet's countries do not exist in IPM database",
  "No Data Selected Dates": "No results for {{ maxDaysInGraphics }} selected days. To see data graphics, make 'click' on buttom 'Weeks' or 'Months'",
  "No Data Selected Date Range": "No results for the date range selected",
  "No Maestro Accounts": " it has not been configured any account in Maestronet database",
  "No Results Found Try Other": "No results found, try a different search selection",
  "Not Assigned": "Unassigned",
  "Not authorized user": "Not authorized user",
  "Not Compare Deal": "Do not compare",
  "Not Confirmed": "Your email is not confirmed. Please, contact with customer support",
  "Not Recommended Browser": "This browser is not recommended. try to access from another supported browser (Chrome or Firefox)",
  "Not Supported Browser": "Please, try to access from another supported browser (Chrome or Firefox)",
  "Number of Agents Commissioned": "# Agents Commissioned",
  "Number of Contracts Commissioning": "# Contracts Commissionning",
  "Number of Tickets commissioned": "# Tickets Commissioned",
  "Open": "Open",
  "on-gross": "On gross",
  "Origin": "Origin",
  "Origin Data": "Origin data",
  "Over Commission": "Overcommission",
  "Password Reset": "Password reset",
  "Password Verification": "Password verification",
  "Payment Content Origin Data": "Payment content origin data",
  "Payment Scheduling": "Payment scheduling",
  "Payment Sending": "Payment sending",
  "Payment Detail": "Payment detail",
  "Payment Detail Of": "Payment detail of file ",
  "Payment Documents": "Payment Documents",
  "Payment ID": "Payment ID",
  "Payments In Error": "There are {{ amountPaymentError }} payment files in status ",
  "Payment Management": "Payment management",
  "Payment Single Saved": "The generation of payment file with name: {{ param }} will begin",
  "Payment Type": "Payment type",
  "Period Bigger Select Data": "If you select a period bigger a three months, you have to select at least an agent, agent group or contract",
  "Period Filter": "Period Filter",
  "Period from": "Period from",
  "Period range": "Period range",
  "Period to": "Period to",
  "Periodic": "Periodic",
  "Point Of Sale": "Point of sale",
  "Previous Page": "Previous",
  "Proceed": "Proceed",
  "Products": "Products",
  "Query": "Query",
  "Question Delete MaestroNet Account": "Are you sure you want to delete the maestronet account?",
  "Question Lock User": "Are you sure to lock the user?",
  "Question Send Communication": "Are you sure to send this communication?",
  "Question Unlock User": "Are you sure to unlock the user?",
  "Reset Password": "Reset password",
  "Rejected" : "Rejected",
  "Remote": "Remote",
  "Remote Description": "Description",
  "Remote Error UniqueKey": "A remote already exists with the same type-host-port",
  "Remote For Responses": "Remote for responses",
  "Remote Host": "Host",
  "Remote Not Found": "A problem ocurred getting information about remote",
  "Remote Port": "Port",
  "Remote Type": "Remote Type",
  "Remote Updated": "Remote updated successfully",
  "Resolved": "Resolved",
  "Reply": "Reply",
  "Reply Communication": "Reply communication",
  "Resp Date": "Resp. date",
  "Response Bsplink": "Response Bsplink",
  "Response File": "Resp. file",
  "Response Date": "Response date",
  "required": "is required",
  "Required Airline": "Airline is required",
  "Required App Name": "Application name is required",
  "Required App Description": "Description of application is required",
  "Required Body": "Body is required",
  "Required CommunicationType": "Communication type is required",
  "Required Contact Name": "Contact name is required",
  "Required Contact Phone": "Contact phone is required",
  "Required Countries": "Countries are required",
  "Required Customer Data": "Please, check 'name', 'shortname' and database fields at Tab 'DB Connections'",
  "Required Customer Email For ApiComm": "Email is required for Public API access",
  "Required Customer Type": "Customer type is required",
  "Required Database Server": "Server is required",
  "Required Database UserName": "Database username is required",
  "Required Description": "Required Description",
  "Required Due Date When ContractRequest": "Due date is required when type is contract request",
  "Required Field": "Required field",
  "Required Host": "Host is required",
  "Required IataCode": "Airline code is required",
  "Required Instance": "Instance name is required",
  "Required Instance-Port": "Either instance or port must have value",
  "Required Only One Field": "Required only one field",
  "Required Remote": "Remote is required",
  "Required Remote Use Type": "Remote Use Type is required",
  "Required Subject": "Subject is required",
  "Required To": "To is required",
  "Required User Directory": "User directory is required",
  "Required Value": "Select a value required",
  "Return Days": "Return days",
  "Role Admin Accelya": "Accelya administrator",
  "Role Agency Accelya": "Travel agency user",
  "Role Airline User": "Airline user",
  "Role Airline User Plus": "Airline user administrator",
  "Role Esmash User": "Esmash user",
  "Role Memo Auditor": "Memo audit user",
  "Role Premium User": "Premium user",
  "Role Static Anonymous": "Anonymous",
  "Routing": "Routing",
  "Save Comment": "Save Comment",
  "Search": "Search",
  "Search By App Name": "Search by application",
  "Search By App Login": "Search by login",
  "Search One Account": "Search one account",
  "Seconds": "Seconds",
  "See Task Detail": "See task detail",
  "Select Cycle Type": "Select cycle type",
  "Select File": "Select file",
  "Select Month": "Select month",
  "Select Period": "Select period",
  "Select Range": "Select range",
  "Select One Airline": "Select one airline",
  "Select One Currency": "Select one currency",
  "Select One Country": "Select one country",
  "Select One Customer": "Select one customer",
  "Select One Customer And Premium": "Select one customer and premium role",
  "Select One Option": "Select one option",
  "Select One Role": "Select one role",
  "Select Year": "Select year",
  "Selected File Is Empty": "The selected file doesn't contain any data",
  "Selected File Not Allowed": "The selected file type is not allowed",
  "Send": "Send",
  "Send Communication": "Send Communication",
  "Send Time": "Send time",
  "Send To": "Send to",
  "Shared Remote": "Shared remote",
  "Single": "Single",
  "SomeComment": "Some comment..",
  "Start Date": "Start Date",
  "State": "State",
  "Status": "Status",
  "Subject Characters Minimum Communications": "The subject must have at least 5 characters",
  "Support Description": "Contact Net Remit Customer Support and access BPO services",
  "Surface": "Surface",
  "Task Detail": "Task detail",
  "Task Template Expired": "Task template is expired because it was edited and a later one has been created",
  "Task Template Updated": "Task template has been updated successfully",
  "Text Cancel": "Are you sure you want to exit without saving the changes?",
  "Text Cancel Payment": "Are you sure you want to cancel this payment?",
  "Text Stop Edit": "Are you sure you want to stop editing without saving the changes?",
  "Text delete": "Are you sure you want to permanently delete the selected register?",
  "Text Save": "Do you want to save the changes before leaving?",
  "Text Send Password": "Are you sure you want to send an email to the user with a link to reset the password to activate the account?",
  "Time": "Time",
  "To": "To",
  "to": "to",
  "To2": "To",
  "Token not valid": "Token is not valid",
  "Tools": "Tools",
  "Tourcodes": "Tour Codes",
  "Total Amount":"Total Amount",
  "Travel Periods": "Travel periods",
  "Trend Number Tickets": "Trend Number of Tickets",
  "Trend Overcomission": "Trend Overcommision",
  "Type": "Type",
  "Unlock": "Unlock",
  "Unlock User": "Unlock user",
  "UpdateUserOk": "User information has been updated correctly",
  "UPDATE": "UPDATE",
  "Updating": "Updating..",
  "Upload To Remote": "Upload to remote",
  "Unselect Deal": "Unselect deal",
  "User Directory": "User Directory",
  "User Disabled": "Your Net Remit account has been disabled. Please, contact with customer support",
  "User Name":"User Name",
  "User Not Admin": "An unexpected problem ocurred. Please, contact with customer support",
  "User Role": "User Role",
  "User Saved Correctly": "User has been saved correctly",
  "Users": "Users",
  "Users Administration": "Users Administration",
  "Verified": "Verified",
  "Verifying": "Verifying",
  "Version": "Version",
  "View Deal": "View deal",
  "View Payment Detail": "View payment detail",
  "Video Tutorial": "Video Tutorial",
  "Volume": "Threshold",
  "Warning Communication Modal Info": "Are you sure you want to close this communication? \nOnce you close a communication you wouldn't be able to reopen it again",
  "Warning Communication Modal Title": "Warning: you will close this communication",
  "web": "Web login",
  "Weeks": "weeks",
  "Welcome": "Welcome to",
  "Will Be Displayed After Saving": "Will be displayed after save",
  "Write New Comment": "Write new comment",
  "Yes": "Yes",
  "Zip": "Zip",
  "% Over Commission": "% Overcommission",

  "Y": "Y",
  "N": "N",

  "Sunday": "Sunday",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",

  "Day-Of-Week Values Must Be Between 1 And 7": "Weekday values must be between 1 and 7",
  "Support For Specifying Both A Day-Of-Week AND A Day-Of-Month Parameter Is Not Implemented": "A day of the week must be specified or have the value '?' if the day of the month has a value",
  "Month Values Must Be Between 1 And 12": "Month values must be between 1 and 12",
  "Day Of Month Values Must Be Between 1 And 31": "Day of month values must be between 1 and 31",
  "Hour Values Must Be Between 0 And 23": "Hour values must be between 0 and 23",
  "Minute And Second Values Must Be Between 0 And 59": "Minute and Second values must be between 0 and 59",
  "Error Next Execution Date": "Error calculating next execution date",
  "Illegal Characters For Seconds": "Illegal characters for seconds",
  "Illegal Characters For Minutes": "Illegal characters for minutes",
  "Illegal Characters For Hour": "Illegal characters for hour",
  "Illegal Characters For Day Month": "Illegal characters for day of the month",
  "Invalid Month Value": "Invalid Month Value",
  "Invalid Day-Of-Week Value": "Invalid day of the week value",
  "The Next Execution Will Be Within Few Seconds": "The next execution will be within few seconds",
  "The Next Execution Will Be On": "The next execution will be on {{ param }}",
  "There Will Be No Next Execution": "There will be no next execution as the periodic payment has been disabled",
  "'?' Can Only Be Specified For Day-Of-Month -OR- Day-Of-Week": "'?' can only be specified for day of the month or day of the week",
  "Administration": {
    "Cleanup": {
      "Errors": {
        "Error Saving Data": "There was an error saving the cleanup data",
        "Error Updating Process Activation": "There was an error updating the cleanup process activation",
        "Error Updating Process Deactivation": "There was an error updating the cleanup process deactivation"
      },
      "Form": {
        "Day Of The Month": "Day of the month (1 to 28)",
        "Day Of The Week": "Day of the week",
        "Errors": {
          "Day Of The Month Required": "Day of the month is mandatory",
          "Day Of The Week Required": "Day of the week is mandatory",
          "Retention Months Required": "Retention months are mandatory",
          "Time Required": "Time is mandatory"
        },
        "Retention Months": "Retention Months (1 to 99)",
        "Select A Day Of The Week": "Select a day of the week",
        "Time Execution": "Time"
      },
      "Information": {
        "Enabled When Filled Form": "Option enabled when deletion runtime is specified",
        "Process Disabled": "Process has been disabled successfully",
        "Process Enabled": "Process has been enabled successfully",
        "Saved Successfully": "Cleanup information has been saved successfully"
      },
      "Last Execution": "Last execution",
      "No Execution Date": "No prior execution",
      "Process Disabled": "Process disabled",
      "Process Enabled": "Process enabled",
      "Status": {
        "Error": "Error",
        "Launched": "Launched",
        "Success": "Finished successfully ",
        "Working": "In process"
      },
      "Title": "Data Cleanup Management",
      "Warning": {
        "Months Retained Detail": "The Retention Months for this customer are: {{ months }}, and the period range selected overlaps the months retained.",
        "Months Retained Title": "Are you sure you want to proceed with this action?",
        "Months Retained Unknown": "The Retention Months for this customer are unknown and the period range selected may overlap the months retained."
      }
    },
    "Customers":{
      "AllowedIP": "Allowed IP",
      "Country Code List": "Country code list",
      "Country Codes": "Country codes",
      "Customer API": "Customer API",
      "Customer API Access": "API Key Manager",
      "Customer Type": "Customer type",
      "Database" : "Database",
      "Database Host": "Host",
      "Database Name": "Database name",
      "Database Params": "Params",
      "Database Password": "Database password",
      "Database Port": "Port",
      "Database Server": "Server",
      "Database User Name": "Database username",
      "Description Shown After Saved": "Available after save",
      "Errors": {
        "Airline Already Exists To This Customer": "The entered airline is already associated to this customer",
        "Allowed IP Already Exists": "IP previously added",
        "Country Codes Not Duplicated": "Country codes must not be duplicated",
        "Error Saving New Customer": "Error saving new customer",
        "Error Updating Customer": "Error updating customer",
        "Incorrect Airline Format": "Format airline must be 3 digits",
        "Incorrect Allowed IP": "IP format incorrect. Example 120.0.0.1",
        "Incorrect Country Format": "Countries of 2 characters separeted by comma. Example XX,XX,XX",
        "Incorrect Database Host": "Database host format incorrect",
        "Incorrect Database Name": "Database name format incorrect",
        "Incorrect Database Params": "Database params format incorrect",
        "Incorrect Database Server": "Database server format incorrect",
        "Must Be One Database Per Product": "Must be one database per product",
        "Required Database Name": "Database name required",
        "Required Host": "Host required",
        "Required Params": "Params required",
        "Required Server": "Server required"
      },
      "General" : "General",
      "Markets" : "Markets",
      "Partnership" : "Partnership",
      "Products" : "Products",
      "Save Customer Ok": "Customer has been saved correctly",
      "Travel Agent": "Travel Agent",
      "Update Customer Ok": "Customer has been updated correctly",
      "Warnings": {
        "No Selected Partners": "There are not partners selected"
      }
    },
    "Data Cleanup Log": {
      "Title": "Data Cleanup Log"
    },
    "Manual Cleanup": {
      "Title": "Manual Cleanup Management"
    },
    "Title": "Administration",
    "Users": {
      "Airline Plus Airline Can Not Be Selected Together": "Airline administrator user and airline can not be selected together",
      "Premium MemoAudit Can Not Be Selected No Airline": "Premium and memo audit can not be selected without airline role"
    }
  },
  "Change Pass": {
    "Change Password Email Sent": "You will receive a confirmation email to reset your password",
    "Current Password": "Current password",
    "Done Redirecting": "Done, redirecting...",
    "Errors": {
      "Current Password Required": "Current password is required",
      "Length Maximum Password": "The maximum password length are {{ quantityMax }} characters",
      "Length Minimum Password": "The minimum password length are {{ quantityMin }} characters",
      "Required Current Password": "Current password is required"
    },
    "New Password": "New password",
    "New Password2": "Re-type the new password"
  },
  "Common": {
    "Accept": "Accept",
    "Actions": "Actions",
    "Add": "Add",
    "Airline": "Airline",
    "AirlineCode": "Airline code",
    "Airlines": "Airlines",
    "Back": "Back",
    "Cancel": "Cancel",
    "Change My Password": "Change my password",
    "Choose One Contract": "Choose one contract",
    "Clear": "Clear",
    "Code": "Code",
    "Contract Code": "Contract code",
    "Countries": "Countries",
    "Country": "Country",
    "Creation Date": "Creation Date",
    "Creation Date Minus Short": "Creation date",
    "Currency": "Currency",
    "Customer": "Customer",
    "Customer Reference": "Customer reference",
    "Customers": "Customers",
    "Cycle":"Cycle",
    "Database Type": "Database type",
    "Date": "Date",
    "Delete": "Delete",
    "Description": "Description",
    "Disable": "Disable",
    "Disabled": "Disabled",
    "Document Type": "Content Type",
    "Edit": "Edit",
    "Email": "Email",
    "Enable": "Enable",
    "Enabled": "Enabled",
    "Errors": {
      "Required Airline": "Airline is mandatory"
    },
    "Execute": "Execute",
    "Execute Now": "Execute now",
    "Execute Time": "Execute time",
    "ExpireDate": "Expire Date",
    "Filter By": "Filter by",
    "Frequency": "Frequency",
    "From": "From",
    "From Date": "From date",
    "Last Name": "Last name",
    "Last Update": "Last update",
    "Month": "Month",
    "Name": "Name",
    "No Data To Show": "There are no data to show",
    "No Results Found": "No results found",
    "Password": "Password",
    "Period": "Period",
    "Period From": "Period from",
    "Period To": "Period to",
    "Required Frequency Choice": "Frequency is required",
    "Save": "Save",
    "Select One Airline": "Select one airline",
    "Select One Country": "Select one country",
    "Select One Customer": "Select one customer",
    "Send": "Send",
    "ShortName": "ShortName",
    "Show": "Show",
    "Status": "Status",
    "To": "To",
    "To Date": "To date",
    "ToDate": "To",
    "User": "User",
    "Username": "Username",
    "View Details": "View details",
    "Warning": "Warning!"
  },
  "Communications": {
    "Assigned": "Assigned",
    "Body Message": "Body Message",
    "Cc": "Cc",
    "Communication Identifier": "Communication identifier",
    "Communication Type": "Communication type",
    "Communication Types": "Communication types",
    "Created by": "Created by",
    "Errors": {
      "Updating Communication": "Error updating the communication, please review the data"
    },
    "New Communication": "New communication",
    "subject": "subject",
    "Subject": "Subject",
    "To Me": "To me"
  },
  "Cron Expressions": {
    "Seconds Option Not Compatible": "Cannot assign executions every second"
  },
  "Cycle":{
    "Bimonthly":{
      "Item": "{{#}} two-month period",
      "Title": "Bimonthly"
    },
    "Quadrimester":{
      "Item": "{{#}} quadrimester",
      "Title": "Quadrimester"
    },
    "Quarter":{
      "Item": "{{#}} quarter",
      "Title": "Quarter"
    },
    "Semester":{
      "Item": "{{#}} semester",
      "Title": "Semester"
    },
    "Year":{
      "Item": "The whole year",
      "Title": "Year"
    }
  },
  "Deals":{
    "Absolute Value": "Absolute value",
    "Achievement": "Achievement",
    "Add Tier": "Add tier",
    "Agreement Code": "Agreement code",
    "Agreement Name": "Agreement name",
    "Associated": "Associated agreements",
    "Associated Agreements Updated": "The stand-alone agreements associated with the threshold contract have been updated",
    "Available": "Available agreements",
    "Back To Base": "Back To Base",
    "Both": "Both",
    "Calculation Base": "Calculation base",
    "Calculation Type": "Calculation type",
    "Deal Name": "Deal name",
    "Deal Scope": "Deal scope",
    "Deleted Ok":"Threshold contract with name {{param}} has been correctly deleted",
    "Discount Upfront":"Discount Upfront",
    "Domestic":"Domestic",
    "Ending Date": "Ending date",
    "Errors": {
      "Getting Associated Contracts": "Error getting associated contracts",
      "Incorrect Deal Name Format": "Incorrect deal name format",
      "Incorrect Maximum Target Per Agent Format": "Incorrect maximum target per agent format",
      "Incorrect Maximum Target Per Deal Format": "Incorrect maximum target per deal format",
      "Length Minimum Deal Name": "The minimum deal name length are {{ quantityMin }} characters",
      "Required Calculation Base": "Calculation base is required",
      "Required Calculation Type": "Calculation type is required",
      "Required Deal Name": "Deal name is required",
      "Required Minimum Value": "Minimum value is required",
      "Required One Tier": "At least one tier is required",
      "Required Payment Currency": "Payment currency is required",
      "Required Payment Type": "Payment type is required",
      "Required Payment Value": "Payment value is required",
      "Required Target Per Agent": "Maximum target per agent is required",
      "Required Target Per Deal": "Maximum target per deal is required",
      "Required Tier Value": "Tier value is required",
      "Required Time Reference": "Time reference is required",
      "Saving New ThresholdContract": "Error saving a new threshold contract",
      "Threshold Contract Updated DealName Cannot Be Modified": "Deal name cannot be modified",
      "Duplicate Deal Name": "A threshold contract with the name '{{dealName}}' already exists. Please use a different name.",
      "Tier Already Exists": "This minimum value already exists",
      "Updating Associated Contracts": "Error updating associated contracts",
      "Updating ThresholdContract": "Error updating a threshold contract"
    },
    "Gross": "Gross",
    "Gross Value": "Gross value",
    "Growth": "Growth",
    "International": "International",
    "Last Month": "Last month",
    "Last Period": "Last period",
    "Manage Agreements": "Manage Agreements",
    "Manage Stand Alone Deals": "Manage stand alone deals associated to threshold contract",
    "Minimum Value": "Minimum value",
    "Month": "Month",
    "Net": "Net",
    "Net Value": "Net value",
    "New Threshold Deal": "New threshold deal",
    "No StandAlone Deals": "This threshold deal has no associated stand-alone agreements and none are available to be associated with it",
    "Number Documents": "Number of documents",
    "Payment Currency": "Payment currency",
    "Payment Type": "Payment type",
    "Payment Value": "Payment value",
    "Percentage": "Percentage",
    "Period": "Period",
    "Report Status": {
      "Created": "Created",
      "Error": "Error",
      "Error Exchange": "Error exchange currency",
      "Ongoing": "Ongoing",
      "Pending": "Pending"
    },
    "Same Last Month": "Same last month",
    "Same Last Period": "Same last period",
    "Same Month Last Year": "Same month last year",
    "Same Period Last Year": "Same period last year",
    "Search By Agreement Name": "Search by agreement name",
    "Starting Date": "Starting date",
    "Target Per Agent": "Target per agent",
    "Target Per Deal": "Target per deal",
    "Text Cancel Create New Threshold Deal": "Are you sure you want to cancel the creation of a new threshold deal without saving it first?",
    "Text Delete Threshold Deal": "Are you sure you want to delete this threshold deal?",
    "Text Delete Threshold Report": "Are you sure you want to delete this threshold report?",
    "Text Reset Page Threshold Deal": "Are you sure you want to create a new threshold deal without saving the changes??",
    "Threshold Contract Created": "The new threshold deal for {{ airline }} in {{ country }} has been created succesfully",
    "Threshold Contract Updated": "The threshold deal for {{ airline }} in {{ country }} has been updated succesfully",
    "Threshold Time Reference": {
      "M": {
        "L": "Last month",
        "SLM": "Same period last month",
        "SLY": "Same period last year"
      },
      "P": {
        "L": "Last period",
        "SLM": "Same period last month",
        "SLY": "Same month last year"
      }
    },
    "Tier": "Tier",
    "Tier Value": "Tier value",
    "Time Reference": "Time reference",
    "Update Threshold Deal": "Update threshold deal"
  },
  "ETL Executions": {
    "All Airlines": "All airlines",
    "End Time": "End time",
    "Errors": {
      "Incorrect Airport Format": "Incorrect airport format",
      "When Removing": "Error when removing the execution"
    },
    "Error Finding": "No ETL executions found",
    "Execution Dates": "Execution dates",
    "Execution Parameters": "Execution parameters",
    "Execution Report": "Detail of execution",
    "Extraction Range": "Extraction range",
    "Launch Time": "Launch time",
    "Label": {
      "D": "D",
      "R": "R"
    },
    "Removed Successfully": "ETL execution removed successfully",
    "Relaunched Successfully": "ETL execution relaunched successfully",
    "Start Time": "Start time",
    "Tooltip": {
      "Delete": "Delete",
      "Relaunch": "Execution Marked for Relaunch",
      "Retry": "Retry process",
      "ToDelete": "Execution Marked for Deletion"
    },
    "Warning": {
      "Delete Message": "You are about to delete the Etl Execution DataByCountryId: {{dataByCountryId}}, this action cannot be undone.",
      "Delete Message All": "You are about to delete all pending and error Etl Executions, this action cannot be undone.",
      "Relaunch Message": "The Etl Execution DataByCountryId: {{dataByCountryId}} will be relaunched.",
      "Relaunch Message All": "Pending or Error Etl Executions will be relaunched.",
      "Title": "Warning: Are you sure you want to continue?"
    }
  },
  "ETL Management": {
    "Configure ETL Extraction": "Configure extraction",
    "Execution Failed": "Could not save any execution",
    "Execution Pending": "Could not save any execution because there are still pending executions for the same Customer and Country",
    "Execution Saved": "The maestro etl extraction request has been added in the queue"
  },
  "Generic Errors": {
    "Error Exchange": "An error occurred while getting the currency exchange in selected dates.",
    "Error Generic Onload": "An error occurred while loading the page data. Please contact with customer support",
    "Error Generic Onload For Support": "An error occurred while loading the page data. Please have a look into log files.",
    "Error Logout": "An error occurred while logging out. Please check the log files.",
    "Existing Email": "The email you are trying to save is associated with another user",
    "File Not Found": "The file you are trying to download is not available",
    "Greater Period From": "Period from is greater than period to",
    "Incorrect Customer Name": "Incorrect customer name format",
    "Incorrect Email Format": "Incorrect email format",
    "Incorrect Numeric Format": "Only numbers",
    "Incorrect Period From": "Incorrect period from format",
    "Incorrect Period To": "Incorrect period to format",
    "Incorrect Tier Format": "Incorrect tier format",
    "Length Maximum Airline": "The maximum airline length are {{ quantityMax }} characters",
    "Length Minimum Name": "The minimum length are {{ quantityMax }} characters",
    "Length Minimum Period": "The minimum period length are 7 characters",
    "Name Not Unique": "The name you are trying to save is associated with another customer",
    "Period To Bigger": "Period to must be bigger then period from",
    "Required Countries": "Countries are required",
    "Required Country": "Country is required",
    "Required Credential": "Credential is required",
    "Required Currency": "Currency is required",
    "Required Customer": "Customer is required",
    "Required Date From": "Date from is required",
    "Required Email": "Email required",
    "Required Login": "Login required",
    "Required Name": "Username required",
    "Required Password": "Password required",
    "Required Password Verification": "Password verification is required",
    "Required Period From": "Period from required",
    "Required Period To": "Period to required",
    "Required Port": "Port is required",
    "Required Retention Months": "Retention Months must be between 0 and 99",
    "Required Role": "Role is required",
    "Required ShortName": "Short name is required",
    "Required User Name": "User name is required",
    "ShortName Not Unique": "The short name you are trying to save is associated with another customer",
    "ShortName Pattern": "Short name format is not correct"
  },
  "Generic Warnings": {
    "No Data By Country" : "No results were obtained for the selected country",
    "No Data To Show": "There are no data to show",
    "Warning": "Warning"
  },
  "Login": {
    "Contact Us": "Contact Us",
    "Enter Credentials": "Please, enter your credentials",
    "Enter MFA Code": "Enter the code from MFA Authenticator app",
    "Errors": {
      "Enter Username": "Please enter your username",
      "Invalid MFA Code": "Please enter a 6-digit code",
      "Invalid MFA Code Attempts": "Invalid MFA Code. Remaining attemps: {{ attemptsRemaining }}",
      "Invalid MFA Code No Attempts": "Invalid MFA Code",
      "Locked": "User has been locked because of too many failed login attempts. Please, try again in {{ lockEndMinutes }} minutes",
      "Login Error": "An error occurred during login, please contact with customer support",
      "User Incorrect": "Wrong credentials",
      "User Password Incorrect": "Wrong credentials. Remaining attemps: {{ attemptsRemaining }}"
    },
    "Forgot Password": "I forgot my password",
    "Information": {
      "Change Language": "Change language",
      "Microsoft Info": "Information about Microsoft Authenticator"
    },
    "Log In": "Login",
    "Login Pattern": "Login format is not correct",
    "MFA": {
      "After Steps": "After completing the steps the app will display a six-digit code to use in login",
      "Back": "Back to login",
      "Code": "Code",
      "Create Account": "In the app, create an account of type 'Work or School'",
      "Enter Code": "If you are unable to scan it, enter the following code manually",
      "Information": "We recommend using Microsoft Authenticator or other similar applications as multi-factor authentication (MFA) software for GNR5. Follow these steps below to set it up:",
      "Install": "Install it on your mobile device",
      "QR Information": "for more information about the app and downloads for iOs and Android devices",
      "QR Link": "Visit Microsoft's Authenticator web-site",
      "Scan": "Scan the QR code displayed using Microsoft Authenticator app, once you identify yourself in login page",
      "URL": "URL"
    },
    "Password Updated Correctly": "Password updated correctly",
    "Passwords Must Match": "Passwords must match",
    "Recovery Email Sent": "If you are a valid user, you will receive an email with a link to a page where you can reset your password",
    "Verify": "Verify"
  },
  "MemoPayments": {
    "accepted" : "Accepted",
    "accepted-Complete": "Accepted",
    "Additional Data": "Additional data",
    "Cancel Payment" : "Cancel payment",
    "cancelled" : "Cancelled",
    "cancelled-Complete": "Cancelled",
    "connection-rejected" : "Connection rejected",
    "connection-rejected-Complete": "Connection rejected (wrong user/pass?)",
    "connection-timed-out" : "Timeout",
    "connection-timed-out-Complete": "Connection timed out",
    "Contact Info": "Contact Info",
    "Content Origin": "Content Origin",
    "Content Type": "Content Type",
    "Created Payments": "Created payments",
    "Customer Details": "Customer Details",
    "Download Report": "Download report",
    "Empty File": "Empty file",
    "Enable Task": "Enable this task",
    "Enter Memo Content": "Introduce a valid memo content",
    "Error Getting Sequence": "An error occurred while getting the sequence data and you will not be able to save the payment. Please contact with customer support",
    "Error Memo Payment Duplicated": "The payment cannot be saved because there is already a payment in the database with the same country, airline and algorithm",
    "Error Memo Payment With Documents Used": "The payment cannot be saved because there is already a payment in the database with any of the document used",
    "Error Memo Payment Period Pending Audit": "Period already included in another payment, please cancel it before continuing",
    "Error Memo Payment Period Sent": "Period already included in another payment",
    "Error Reprocessing Payment": "An error happened to reprocessing the payment. Please contact with customer support",
    "Error Saving Memo Payment": "An error occured while trying to save the new payment",
    "error-creating-file" : "Error creating file",
    "error-creating-file-Complete": "Error creating/sending payment file",
    "error-extracting-data" : "Error extracting data",
    "error-extracting-data-Complete" : "Error extracting data from file",
    "Extraction End Date": "Extraction end",
    "Extraction Start Date": "Extraction start",
    "FileSequence Already Exists": "File sequence already exists",
    "From Doc": "From Memo Doc",
    "From Document": "From Document",
    "From Document ACM": "From ACM",
    "From Document ADM": "From ADM",
    "Hide Disabled Tasks": "Hide disabled tasks",
    "Incentive Amount": "Incentive amount",
    "Incorrect Extraction End Date": "Extraction end date must be higher than extraction start date.",
    "Incorrect Extraction End Date Today": "Extraction end date must be higher or equal than today.",
    "Incorrect Format": "Incorrect Format",
    "Incorrect Memo Content Format": "The correct format is: agent;Amount(Must be non-zero); Currency(ISO) Decimals;Related Doc.(optional, must be non-zero) 1234567;10.23;EUR2;1234567890",
    "Incorrect Numeric Higher0 Format": "Only admits numeric characters higher than zero",
    "Incorrect Payment Type US": "If USA is the selected country, just 'commission' is the valid value",
    "Incorrect RMIC US": "If USA is the selected country, RMIC must be empty",
    "Incorrect To Document": "To document must be higher or equal than from document",
    "Incorrect Vat Fare": "If fare is the payment type, VAT must be empty",
    "Incorrect Vat Format": "Incorrect VAT format",
    "Incorrect Vat US": "If USA is the selected country, VAT must be empty",
    "Invalid Memostatus": "Incorrect new status. The status to be able to update must be cancelled or sending",
    "Length Maximum ReasonMemo": "Reason for memo maximum length are {{ quantityMax }} characters",
    "List Memo Docs": "List of memo documents",
    "List Related Docs": "List of related documents",
    "Max & Minimum Value File Sequence": "Range must be from {{ minFileSequence }} to {{ maxFileSequence }} (both inclusive)",
    "Max Related": "Max. Related",
    "Memo Content": "Memo Content",
    "Memo Content Origin" : "Memo content origin",
    "Memo Document": "Memo document",
    "Method Not Allowed": "Incorrect previous status. Memopayment to be able to update must be cancelled or prepared",
    "New Payment": "New Payment File",
    "Next Document": "Next Document",
    "No Database Found": "Sorry, there is no database configured for the current Customer",
    "No Payment Detail": "Sorry, there is no payment detail to show yet",
    "No Payments": "Sorry, there are no payments to show yet",
    "no-data-found": "No data found",
    "no-data-found-Complete": "No data found",
    "Only prepared and pending status can be cancelled": "Only prepared and pending status can be cancelled",
    "Only prepared status can be sent": "Only prepared status can be sent",
    "outdated-agent-headers": "Outdated agent headers",
    "outdated-agent-headers-Complete": "Outdated agent headers",
    "partial-reject" : "Partial reject",
    "partial-reject-Complete": "Partial reject",
    "Payee-Payer Agent": "Payee/payer agent",
    "Payment Content Origin Data": "Payment content origin data",
    "Payment Detail": "Payment detail",
    "Payment Detail Of": "Payment detail of file ",
    "Payment Management": "Payment Management",
    "Payment Scheduling": "Payment scheduling",
    "Payment Sending": "Payment sending",
    "Payment Single Saved": "The generation of payment file with name: {{ param }} will begin",
    "Payment Type": "Payment Type",
    "Payments In Error": "There are {{ amountPaymentError }} payment files in status ",
    "pending" : "Pending",
    "pending-audit" : "Pending audit",
    "pending-audit-Complete": "Pending audit",
    "pending-Complete": "Pending (waiting file creation)",
    "prepared" : "Prepared",
    "prepared-Complete": "Prepared (file created)",
    "Programmed Payments": "Programmed payments",
    "Ranges": "Ranges",
    "Reason For Memo": "Reason for memo",
    "Reject Payment" : "Reject payment",
    "Related Document": "Related document",
    "Reprocess Payment": "Reprocess payment",
    "Request Airline Auditory": "Request for airline auditory",
    "Required Content Type": "Content type is required",
    "Required Document Type": "Document type is required",
    "Required From Document": "From document is required",
    "Required MaxRelated": "Max.Related is required",
    "Required Memo Content Origin Choice": "Memo content origin is required",
    "Required Payment Documents": "Payment documents are required",
    "Required PaymentType": "Payment type is required",
    "Required Sequence": "The sequence is required",
    "Required To Document": "To document is required",
    "Required Upload To Remote": "Upload to remote is required",
    "Select": "Select",
    "Send Attachment": "Send Attachment",
    "Send BspLink": "Send to BspLink",
    "Send To Remote": "Send to remote server",
    "sending" : "Sending",
    "Sending BspLink": "Sending to BspLink",
    "sending-Complete": "Sending by ftp",
    "sent" : "Sent",
    "sent-Complete": "Sent to Bsplink",
    "Sequence": "Sequence",
    "Show Disabled Tasks": "Show disabled tasks",
    "Text Reset Page Memo": "Are you sure you want to create a new memo without saving the changes?",
    "Text Reset Page Memo Frequency": "Data related to payment frequency will be reseted, are you sure you want to change the frequency?",
    "To Doc": "To Memo Doc",
    "To Document": "To Document",
    "To Document ACM": "To ACM",
    "To Document ADM": "To ADM",
    "Total Amounts": "Total amounts",
    "total-reject" : "Rejected",
    "total-reject-Complete": "Total reject",
    "Type Content": "Type and content",
    "unable-to-connect": "No connection",
    "unable-to-connect-Complete": "Unable to connect (wrong configuration?)",
    "unexpected-error": "Error",
    "unexpected-error-Complete": "Unexpected error",
    "View Memos List": "View memos list",
    "Warning Change Frequency": "If the frequency is modified, the data entered will be lost.",
    "Warning Report Not Created": "* Report cannot be downloaded because it has not been created yet.",
    "Warning XML Not Created": "* Memos list cannot be showed up because they have not been created yet."
  },
  "Menu Help": {
    "Analytics": "Analytics",
    "Change My Password": "Change My Password",
    "Contract Management": "Contract Management",
    "CRM": "CRM",
    "Download Doc": "Download Documentation",
    "KPI Dashboard": "KPI Dashboard",
    "Profile": "Profile",
    "Release Notes" : "Release Notes",
    "Reports": "Reports",
    "Tutorial Index": "Tutorial Index",
    "Video Tutorial": "Vídeo Tutorial"
  },
  "Menus": {
    "Administration": {
      "DataCleanUp": "Data Cleanup",
      "DataCleanupLog": "Data Cleanup Log",
      "DataManagement": "Data Management",
      "IPM ETL Manager": "IPM-ETL Manager",
      "Manual Data CleanUp": "Manual Data Cleanup",
      "New Execution": "New ETL Execution",
      "Welcome Message": "Welcome Message"
    },
    "Contract Management":{
      "Backend Contracts": "Back-end Contracts",
      "Contract Management": "Contract Management",
      "ETL Management": "ETL Management",
      "Frontend Contracts":{
        "Change Market": "Change Market",
        "Deals": {
          "Additional Conditions": "Additional Conditions",
          "Copy": "Copy",
          "Copy Deal": "Contract",
          "Copy of Multicountry And Multiairline Deals": "Multicountry & Multiairlines",
          "Copy Version": "Version",
          "Create": "Create",
          "Create Deal": "Contract",
          "Create Deal From Other": "Contract From Other",
          "Create Version": "Version",
          "Deals": "Contracts",
          "Delete": "Delete",
          "Mixed Conditions": "Mixed Conditions",
          "Modify": "Modify",
          "Modify Deal": "Contract",
          "Priorities": "Priorities"
        },
        "Frontend Contracts": "Up-Front Contracts",
        "List of Contracts": "List of Contracts",
        "Maintenance": {
          "Application of Incentives": "Application of Incentives",
          "Basic Parameters": "Basic Parameters",
          "Carrier Segments": "Carrier Segments",
          "Carriers": "Carriers",
          "Generic Cities": "Generic Cities",
          "Group of Tour Codes": "Tour Codes",
          "Groups": "Groups",
          "Groups of Agents": "Agents",
          "Groups of Cities": "Cities",
          "Groups of Groups of Agents": "Group of Agents",
          "Load file with group of agents": "Group of Agents",
          "Load file with group of cities": "Group of Cities",
          "Load file with group of tour codes": "Group of tour codes",
          "Load Group File": "Load Group | File",
          "Maintenance": "Maintenance",
          "Parameters": "Parameters",
          "Season Dates": "Season Dates",
          "Tour Code": "Tour Code"
        },
        "Master Tables": {
          "Agents": "Agents",
          "Airports": "Airports",
          "Carriers": "Carriers",
          "Groups of Agents": "Groups of Agents",
          "Master Tables": "Master Tables"
        },
        "Queries": {
          "Active Deals": "Active",
          "Agent in Groups": "Agents in Groups",
          "Cities in Groups": "Cities in Groups",
          "Condition": "Condition",
          "Deactivated Deals": "Deactivated",
          "Deals": "Contracts",
          "Expired Deals": "Expired",
          "FAC simile": "FAC-simile",
          "Groups": "Groups",
          "Groups of Agents":"Agents",
          "Groups of Cities": "Cities",
          "Groups of Groups": "Groups of Agent Groups",
          "Mismatch Condition Agreement": "Mismatch",
          "Queries": "Queries",
          "Settled": "Settled",
          "Tickets": "Tickets"
        },
        "Select Account": "Select Market"
      },
      "Threshold Contracts Management": "Threshold Target Based Contracts"
    },
    "Logout": "Logout",
    "Profile": "Profile"
  },
  "MFA": {
    "Values": {
      "Mobile": "Mobile Authenticator",
      "None": "None"
    }
  },
  "Mixed Conditions": {
    "Airport From": "Airport from",
    "Airport To": "Airport to",
    "Blackout Dates": "BLACKOUT DATES",
    "Carrier": "Carrier",
    "Carrier Class": "CARRIER + CLASS",
    "Carrier Flight Number": "CARRIER + FLIGHT NUMBER",
    "Class": "Class",
    "Conditions": "Conditions",
    "Errors": {
      "Flight Date From Bigger": "Flight date to must be equal or bigger than Flight date from",
      "Incorrect Airport Format": "Incorrect airport format",
      "Incorrect Carrier Format": "Incorrect carrier format",
      "Incorrect Class Format": "Incorrect class format",
      "Incorrect Fare Basis Format": "Incorrect fare basis format",
      "Incorrect Flight Number Format": "Incorrect flight number format",
      "Length Minimum Airport": "The minimum airport length are {{ quantityMax }} characters",
      "Length Minimum Carrier": "Minimum carrier length are {{ quantityMax }} characters",
      "Length Minimum Fare Basis": "Minimum fare basis length are {{ quantityMax }} characters",
      "Mixed Condition Repeated": "Mixed condition already exists",
      "Required Carrier": "Carrier is required",
      "Required Class": "Class is required",
      "Required Fare Basis": "Fare basis is required",
      "Required Flight Date From": "Flight date from required",
      "Required Flight Date To": "Flight date to required",
      "Required Flight Number From": "Flight number from required",
      "Required Flight Number To": "Flight number to required",
      "The Following Carriers Were Not Found": "The following carriers were not found: {{ param }}",
      "The Following Journeys Were Not Found": "The following journeys were not found: {{ param }}"
    },
    "Exclusive": "Exclusive",
    "Fare Basis": "Fare Basis",
    "Fare Basis Class": "FARE BASIS + CLASS",
    "Flight Date From": "Flight date from",
    "Flight Date To": "Flight date to",
    "Flight Number From": "Flight number from",
    "Flight Number To": "Flight number to",
    "Inclusive": "Inclusive",
    "Indistinct": "Indistinct",
    "Saved Correctly": "Mixed conditions have been saved correctly",
    "To": "To"
  },
  "Modal":{
    "Confirmation": "Confirmation",
    "ConfirmDelete": "Are you sure you want to delete {{ param }}?",
    "Deleted": "Remote account deleted",
    "Error": "Error",
    "Info": "Information",
    "Success": "Success",
    "Warning": "Warning"
  },
  "primeng": {
    "clear": "Clear",
    "dayNamesMin": ["Su","Mo","Tu","We","Th","Fr","Sa"],
    "monthNames": ["January","February","March","April","May","June","July","August","September","October","November","December"],
    "monthNamesShort": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
    "today": "Today"
  },
  "RemoteAccounts": {
    "Administration": "Remote Accounts Administration",
    "AirlineCode": "Airline",
    "Cannot Delete Type": "It is not possible to delete remote accounts of type db-ss or db-ifx",
    "CountryCode": "Country",
    "Credential": "Credential",
    "Credential LoginType Exists": "There is already a credential created with that type and that login",
    "Customer Accelya Remote Shared": "If customer is Accelya, remote should be shared",
    "Customer Short Name": "Customer",
    "CustomerHaveDb": "There is already a database created asociated to this customer",
    "Database Validation Credential": "Credential must be SQL Server or Informix",
    "Database Validation Remote": "Remote must be SQL Server or Informix",
    "DbMaestro Same Country": "There is already a MAESTRO database created with same country",
    "Description": "Description",
    "EditRemoteAccount": "Edit Remote Account",
    "Error Connection When Deleting": "There was an error deleting the account due to a failed connection to IPM database to check if there are payments",
    "Error Deleting Database Types": "It is not possible to delete remote accounts of type {{ type }}",
    "Error Deleting Remote Account": "Error trying to delete the remote account",
    "Error Get Remote": "Error trying to get a remote",
    "Error Get Remote Account": "Error trying to get a remote account",
    "Error Get Remote Accounts": "Error trying to get remote accounts",
    "Error Password Format": "Password format is not correct",
    "Error Saving Remote Account": "Error trying to saved the remote account",
    "Error Updating Remote Account": "Error trying to update the remote account",
    "Expiration Date": "Expiration date",
    "Incorrect Different RemoteUserType": "The remote type is different from the credential type",
    "Memo Periodic With Remote": "Remote account cannot be deleted because the remote {{ param }} is associated with some payments",
    "New Remote Account": "New remote account",
    "Remote Description": "Remote",
    "Remote TypeHostPort Exists": "There is already a remote created with that type, host and port",
    "Remote Use Type": "Type",
    "Saved": "The remote account has been saved successfully",
    "Updated": "The remote account has been updated successfully"
  },
  "Reports": {
    "Conversion": "Convert to:",
    "Download Report" : "Download report",
    "Errors": {
      "Error Check Reports": "Please, check the generated reports",
      "Error Deleting Report": "An error ocurred deleting the report",
      "Error Downloading Report": "An error ocurred downloading the report",
      "Error Generating Report": "An error occurred while saving new report",
      "Error Sending Report": "An error ocurred sending the report"
    },
    "No Data To Filter": "There is no data to create a commissioned tickets report.",
    "Remove Report" : "Remove report",
    "Report Creation": "The creation of your report can take some minutes",
    "Report Generation": "Generation of report has started",
    "Report Keep Browsing": "Meanwhile you can keep browsing the web site and get back later",
    "Report Submission": "Report submission",
    "Reports": "Reports",
    "Select Agents": "Select agents",
    "Select Agents Groups": "Select agents group",
    "Select Airlines": "Select airlines",
    "Select Contracts": "Select contracts",
    "Select Countries": "Select countries",
    "Select Document Types": "Select document types",
    "Select Range": "Select dates",
    "Send Report": "Send report",
    "Volume": {
      "No Database Configured": "No database configured"
    },
    "Warning": {
      "No Data" : "No results were obtained for the selected country."
    }
  },
  "Table Commons": {
    "Clear": "Clear",
    "Clear Filter": "Clear filter",
    "Not Found": "No result found",
    "Search Keyword": "Search keyword"
  },
  "Tableau": {
    "Administration": "Tableau Administration",
    "Configuration Saved Successfully": "Tableau configuration has been saved successfully",
    "Edit Global Configuration Confirmation": "You are going to edit Tableau configuration for all the customers, are you sure you want to proceed?",
    "Error Getting Configuration": "Error getting Tableau configuration",
    "Error Saving Configuration": "Error trying to save Tableau configuration",
    "Errors": {
      "Server Required": "Server is required",
      "Site Required": "Site is required"
    },
    "Project": "Project",
    "Server": "Server",
    "Site": "Site",
    "Title": "Tableau",
    "View": "View"
  },
  "User": {
    "Accept Receive News Product": "I accept to receive news about the product",
    "Address": "Address",
    "City": "City",
    "Company Code": "Company code / Airline",
    "Company Name": "Company name",
    "Errors": {
      "Airline Code Only Numerics": "Airline should only contain letters",
      "City Only Letters": "City should only contain letters",
      "Country Only Letters And Numbers": "Country should only contain letters and/or numbers",
      "First Name Only Letters": "First name should only contain letters",
      "Last Name Only Letters": "Last name should only contain letters",
      "Length Maximum Address": "The maximum length address are {{ quantityMax }} characters",
      "Length Maximum City": "The maximum length city are {{ quantityMax }} characters",
      "Length Maximum Company": "The maximum length company are {{ quantityMax }} characters",
      "Length Maximum Country": "The maximum length country are {{ quantityMax }} characters",
      "Length Maximum FirstName": "The maximum length name are {{ quantityMax }} characters characters",
      "Length Maximum LastName": "The maximum length last name are {{ quantityMax }} characters",
      "Length Maximum Minimum Email": "The minimum length email are {{ quantityMin }} characters and maximum {{ quantityMax }}",
      "Length Maximum Phone": "The maximum length phone are {{ quantityMax }} characters",
      "Length Maximum Position": "The maximum length position are {{ quantityMax }} characters",
      "Length Maximum State": "The maximum length state are {{ quantityMax }} characters",
      "Length Maximum Zip": "The maximum length zip are {{ quantityMax }} characters",
      "Length Minimum Password": "The minimum password length are {{ quantityMax }} characters",
      "Length Required IataCode": "The length IATA code must be {{ quantityMax }} characters",
      "Required FirstName": "Name is required",
      "Required MFA Method": "MFA Method is required",
      "Reset Password": "An error happened to reset the password. Please contact with customer support",
      "State Only Letters": "State should only contain letters",
      "User Locked": "User is locked"
    },
    "First Name": "First Name",
    "MFA Method": "MFA Method",
    "Phone": "Phone",
    "Position": "Position",
    "Province": "Province",
    "Reset MFA": "Restart MFA at the next login",
    "Role": "Role",
    "Save Profile": "Save profile"
  },
  "Welcome Message": {
    "Error Getting": "Error trying to get the welcome message.",
    "Error Saving": "Error trying to save the new welcome message.",
    "HTML Format": "Welcome message has not html format.",
    "Info Message": "This message will be shown to all users in the welcome page.",
    "Multiple Messages": "There is more than one welcome message stored in the database.",
    "Saved": "A new welcome message has been created.",
    "Set Read": "Welcome message has been set as read and it won't be showed again.",
    "Show Message": "Mark this message as read and do not show it again",
    "Tittle": "Welcome message"
  }
}
